import { rankWith, scopeEndIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { SymbolPicker } from 'src/features/symbol-picker';

interface SymbolFinderControlProps {
    data: any;
    path: string;
    description?: string;
    errors: string;
    visible: boolean;

    handleChange(path: string, value: any): void;
}

const SymbolFinderControlComponent = ({
    data,
    path,
    description,
    errors,
    visible,
    handleChange,
}: SymbolFinderControlProps) => {
    return visible ? (
        <div>
            <SymbolPicker
                value={data}
                onChange={(value: string) => handleChange(path, value)}
                allowedInstrumentTypes={['equity']}
            />
            {description && <div className="mt-[3px] text-sm leading-[1.66] text-white/70">{description}</div>}
            {errors && <div className="mt-[3px] text-sm leading-[1.66] text-[#f44336]">{errors}</div>}
        </div>
    ) : null;
};

export const SymbolFinderControlTester = rankWith(
    3, //increase rank as needed
    scopeEndIs('symbol'),
);

export const SymbolFinderControl = withJsonFormsControlProps(SymbolFinderControlComponent);
